import React from 'react'
import Loading, { Path } from '../../styles/loading'

export default ({ isButton }) => (
  <Loading
    viewBox="0 0 50 50"
    isButton={isButton}
  >
    <Path
      cx="25"
      cy="25"
      r={isButton ? "10" : "15"}
      fill="none"
      strokeWidth={isButton ? "3" : "5"}
      isButton={isButton}
    />
  </Loading>
)
